import { Link } from "react-router-dom";
import { MapPin, Building2, Wallet } from "lucide-react";
import dayjs from "dayjs";
import { useLanguage } from "../i18n/LanguageContext";

export default function JobCard({ job }) {
  const { t, lang } = useLanguage();
  const locale = lang === "fr" ? "fr-FR" : lang === "es" ? "es-ES" : "en-US";
  return (
    <Link
      to={`/jobs/${job.job_id}`}
      data-testid={`job-card-${job.job_id}`}
      className="group flex flex-col rounded-md border-2 border-slate-900 bg-white p-6 transition-transform duration-200 hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_rgba(15,23,42,1)]"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-heading text-lg font-bold tracking-tight text-slate-900 group-hover:text-sky-600">
            {job.title}
          </h3>
          <p className="mt-1 flex items-center gap-1.5 text-sm font-medium text-slate-600">
            <Building2 className="h-4 w-4" strokeWidth={2} /> {job.company_name}
          </p>
        </div>
        <span className="shrink-0 rounded-full border border-slate-900 bg-sky-100 px-2.5 py-0.5 text-xs font-semibold text-slate-900">
          {t(`jobTypes.${job.job_type}`)}
        </span>
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-600">
        <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4" strokeWidth={2} />{job.location}</span>
        {job.salary && <span className="flex items-center gap-1.5"><Wallet className="h-4 w-4" strokeWidth={2} />{job.salary}</span>}
      </div>
      <div className="mt-4 flex items-center justify-between border-t border-slate-200 pt-3">
        <span className="rounded-full border border-slate-900 bg-yellow-100 px-2.5 py-0.5 text-xs font-semibold text-slate-900">
          {t(`categories.${job.category}`)}
        </span>
        <span className="text-xs text-slate-500">
          {t("jobs.postedOn")} {dayjs(job.created_at).locale(locale).format("DD/MM/YYYY")}
        </span>
      </div>
    </Link>
  );
}
